import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

@Pipe({
    name: 'marked',
    standalone: false,
})
export class MarkedPipe implements PipeTransform {
    public transform(value: string): string {
        value = value ?? '';
        value = value.replace(/^"(.*)"$/, '$1').trim();
        return marked.parse(value) as string;
    }
}
